var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8 1.66699C5.81667 1.66699 4.04167 3.44199 4.04167 5.62533C4.04167 7.76699 5.71667 9.50033 7.9 9.57533C7.96667 9.56699 8.03333 9.56699 8.08333 9.57533C8.1 9.57533 8.10833 9.57533 8.125 9.57533C8.13333 9.57533 8.13333 9.57533 8.14167 9.57533C10.275 9.50033 11.95 7.76699 11.9583 5.62533C11.9583 3.44199 10.1833 1.66699 8 1.66699Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2341 11.7943C9.90911 10.2443 6.11745 10.2443 3.77578 11.7943C2.71745 12.5027 2.13411 13.461 2.13411 14.486C2.13411 15.511 2.71745 16.461 3.76745 17.161C4.93411 17.9443 6.46745 18.336 8.00078 18.336C9.53411 18.336 11.0674 17.9443 12.2341 17.161C13.2841 16.4527 13.8674 15.5027 13.8674 14.4693C13.8591 13.4443 13.2841 12.4943 12.2341 11.7943Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1578 6.11512C17.2911 7.73179 16.1411 9.14846 14.5495 9.34012C14.5411 9.34012 14.5411 9.34012 14.5328 9.34012H14.5078C14.4578 9.34012 14.4078 9.34012 14.3661 9.35679C13.5578 9.39846 12.8161 9.14012 12.2578 8.66512C13.1161 7.89846 13.6078 6.74846 13.5078 5.49846C13.4495 4.82346 13.2161 4.20679 12.8661 3.68179C13.1828 3.52346 13.5495 3.42346 13.9245 3.39012C15.5578 3.24846 17.0161 4.46512 17.1578 6.11512Z",
    fill: "#35446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8236 13.8257C18.7569 14.634 18.2402 15.334 17.3736 15.809C16.5402 16.2673 15.4902 16.484 14.4486 16.459C15.0486 15.9173 15.3986 15.2423 15.4652 14.5257C15.5486 13.4923 15.0569 12.5007 14.0736 11.709C13.5152 11.2673 12.8652 10.9173 12.1569 10.659C13.9986 10.1257 16.3152 10.484 17.7402 11.634C18.5069 12.2507 18.8986 13.0257 18.8236 13.8257Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon02);
export default __webpack_public_path__ + "static/media/call-icon-02.3f47927357c6a7e6c12442cffa209c2e.svg";
export { ForwardRef as ReactComponent };